import type { SVGProps } from 'react';
const SvgIconRealm = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.926 2.588a1.25 1.25 0 0 1 2.148 0l5.37 9.023A1.25 1.25 0 0 1 13.37 13.5H2.63a1.25 1.25 0 0 1-1.075-1.89zM8 3.716 3.07 12h9.86z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconRealm;
